import React from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Head from "./head/Head";

const Layout = ({ title, ...props }) => {

  return (
    <>
      <Head title={!title && 'Loading'} />
      <div className="nk-app-root">
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content">
            <Outlet />
          </div>
        </div>
      </div>
      <ToastContainer position="top-center" />
    </>
  );
};
export default Layout;
